export default {
  moduleName: "compliance",
  namespaced: true,
  state: {
    currentCompliance: undefined,
  },
  getters: {
    currentCompliance: (state) => state.currentCompliance,
  },
  mutations: {
    currentCompliance: (state, value) => (state.currentCompliance = value),
  },
  actions: {
    async setCurrentCompliance({ commit }, payload) {
      return commit("currentCompliance", payload);
    },
  },
};
